<p-toast position="top-center"></p-toast>

@if (app.i18n.data) {
  <router-outlet></router-outlet>
}
